function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1920(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 31.47,
    height: 13.56,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.39
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.735,
    y: 6.78,
    fontFamily: "Arial"
  }, "\n        Cook\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 13.56,
    width: 31.47,
    height: 31.63,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.93375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.735,
    y: 29.375,
    fontFamily: "Arial"
  }, "\n        Mahnomen\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 45.2,
    width: 31.47,
    height: 44.37,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.93375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.735,
    y: 67.385,
    fontFamily: "Arial"
  }, "\n        Red_Lake\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 89.57,
    width: 31.47,
    height: 50.85,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.93375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.735,
    y: 114.99499999999999,
    fontFamily: "Arial"
  }, "\n        Traverse\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 140.42,
    width: 31.47,
    height: 51.19,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.8675
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.735,
    y: 166.015,
    fontFamily: "Arial"
  }, "\n        Lake\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 191.61,
    width: 31.47,
    height: 53.49,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.147
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.735,
    y: 218.35500000000002,
    fontFamily: "Arial"
  }, "\n        Clearwater\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 245.1,
    width: 31.47,
    height: 59.27,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.245
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.735,
    y: 274.735,
    fontFamily: "Arial"
  }, "\n        Wilkin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 304.37,
    width: 31.47,
    height: 62,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.4957142857142856
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.735,
    y: 335.37,
    fontFamily: "Arial"
  }, "\n        Stevens\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 366.37,
    width: 31.47,
    height: 64.14,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.4957142857142856
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.735,
    y: 398.44,
    fontFamily: "Arial"
  }, "\n        Hubbard\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 430.5,
    width: 31.47,
    height: 65.38,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.4966666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.735,
    y: 463.19,
    fontFamily: "Arial"
  }, "\n        Big_Stone\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 495.89,
    width: 31.47,
    height: 67.75,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.294
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.735,
    y: 529.765,
    fontFamily: "Arial"
  }, "\n        Grant\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 563.64,
    width: 31.47,
    height: 68.11,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.4957142857142856
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.735,
    y: 597.6949999999999,
    fontFamily: "Arial"
  }, "\n        Kanabec\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 631.76,
    width: 31.47,
    height: 68.24,
    style: {
      fill: "#660000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.4966666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.735,
    y: 665.88,
    fontFamily: "Arial"
  }, "\n        Sherburne\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 31.47,
    y: 0,
    width: 44.12,
    height: 48.75,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.010909090909091
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.53,
    y: 24.375,
    fontFamily: "Arial"
  }, "\n        Koochiching\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 75.59,
    y: 0,
    width: 45.47,
    height: 48.75,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.4957142857142856
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 98.325,
    y: 24.375,
    fontFamily: "Arial"
  }, "\n        Kittson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 121.06,
    y: 0,
    width: 46.22,
    height: 48.75,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.602857142857142
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 144.17000000000002,
    y: 24.375,
    fontFamily: "Arial"
  }, "\n        Lincoln\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 167.29,
    y: 0,
    width: 47.63,
    height: 48.75,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.9383333333333335
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 191.105,
    y: 24.375,
    fontFamily: "Arial"
  }, "\n        Wadena\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 214.92,
    y: 0,
    width: 50.43,
    height: 48.75,
    style: {
      fill: "#660000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.1875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 240.135,
    y: 24.375,
    fontFamily: "Arial"
  }, "\n        Rock\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 265.35,
    y: 0,
    width: 50.6,
    height: 48.75,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 290.65000000000003,
    y: 24.375,
    fontFamily: "Arial"
  }, "\n        Benton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 315.95,
    y: 0,
    width: 50.84,
    height: 48.75,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 341.37,
    y: 24.375,
    fontFamily: "Arial"
  }, "\n        Roseau\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 366.79,
    y: 0,
    width: 52.21,
    height: 48.75,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 392.89500000000004,
    y: 24.375,
    fontFamily: "Arial"
  }, "\n        Pennington\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 418.99,
    y: 0,
    width: 53.11,
    height: 48.75,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.416666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 445.545,
    y: 24.375,
    fontFamily: "Arial"
  }, "\n        Pipestone\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 472.1,
    y: 0,
    width: 55.46,
    height: 48.75,
    style: {
      fill: "#660000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.75
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 499.83000000000004,
    y: 24.375,
    fontFamily: "Arial"
  }, "\n        Dodge\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 527.56,
    y: 0,
    width: 56.43,
    height: 48.75,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 555.775,
    y: 24.375,
    fontFamily: "Arial"
  }, "\n        Murray\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 583.99,
    y: 0,
    width: 57.11,
    height: 48.75,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 612.545,
    y: 24.375,
    fontFamily: "Arial"
  }, "\n        Aitkin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 641.1,
    y: 0,
    width: 58.9,
    height: 48.75,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.09375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 670.5500000000001,
    y: 24.375,
    fontFamily: "Arial"
  }, "\n        Watonwan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 31.47,
    y: 48.75,
    width: 57.41,
    height: 50.71,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.142
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 60.175,
    y: 74.105,
    fontFamily: "Arial"
  }, "\n        Scott\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 31.47,
    y: 99.46,
    width: 57.41,
    height: 51.61,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.601666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 60.175,
    y: 125.26499999999999,
    fontFamily: "Arial"
  }, "\n        Isanti\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 31.47,
    y: 151.07,
    width: 57.41,
    height: 52.19,
    style: {
      fill: "#660000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.218999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 60.175,
    y: 177.165,
    fontFamily: "Arial"
  }, "\n        Cottonwood\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 31.47,
    y: 203.26,
    width: 57.41,
    height: 52.66,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 13.165
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 60.175,
    y: 229.58999999999997,
    fontFamily: "Arial"
  }, "\n        Pope\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 31.47,
    y: 255.92,
    width: 57.41,
    height: 53.33,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 13.3325
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 60.175,
    y: 282.585,
    fontFamily: "Arial"
  }, "\n        Cass\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 31.47,
    y: 309.25,
    width: 57.41,
    height: 53.97,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.995
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 60.175,
    y: 336.235,
    fontFamily: "Arial"
  }, "\n        Norman\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 31.47,
    y: 363.21,
    width: 57.41,
    height: 55.25,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.892857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 60.175,
    y: 390.835,
    fontFamily: "Arial"
  }, "\n        Carlton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 31.47,
    y: 418.47,
    width: 57.41,
    height: 55.52,
    style: {
      fill: "#660000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.9314285714285715
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 60.175,
    y: 446.23,
    fontFamily: "Arial"
  }, "\n        Houston\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 31.47,
    y: 473.99,
    width: 57.41,
    height: 55.81,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.581
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 60.175,
    y: 501.895,
    fontFamily: "Arial"
  }, "\n        Mille_Lacs\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 31.47,
    y: 529.8,
    width: 57.41,
    height: 56.36,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.272
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 60.175,
    y: 557.9799999999999,
    fontFamily: "Arial"
  }, "\n        Anoka\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 31.47,
    y: 586.15,
    width: 57.41,
    height: 56.66,
    style: {
      fill: "#660000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.443333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 60.175,
    y: 614.48,
    fontFamily: "Arial"
  }, "\n        Sibley\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 31.47,
    y: 642.81,
    width: 57.41,
    height: 57.19,
    style: {
      fill: "#660000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.14875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 60.175,
    y: 671.405,
    fontFamily: "Arial"
  }, "\n        Nicollet\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 88.88,
    y: 48.75,
    width: 57.56,
    height: 58.43,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.593333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 117.66,
    y: 77.965,
    fontFamily: "Arial"
  }, "\n        Waseca\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 146.45,
    y: 48.75,
    width: 57.67,
    height: 58.43,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.534
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 175.285,
    y: 77.965,
    fontFamily: "Arial"
  }, "\n        Swift\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 204.11,
    y: 48.75,
    width: 57.71,
    height: 58.43,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.21375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 232.965,
    y: 77.965,
    fontFamily: "Arial"
  }, "\n        Chippewa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 261.82,
    y: 48.75,
    width: 58.43,
    height: 58.43,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.4946153846153845
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 291.03499999999997,
    y: 77.965,
    fontFamily: "Arial"
  }, "\n        Lac_qui_Parle\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 320.25,
    y: 48.75,
    width: 58.78,
    height: 58.43,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.347142857142858
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 349.64,
    y: 77.965,
    fontFamily: "Arial"
  }, "\n        Jackson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 379.03,
    y: 48.75,
    width: 62.11,
    height: 58.43,
    style: {
      fill: "#660000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.347142857142858
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 410.085,
    y: 77.965,
    fontFamily: "Arial"
  }, "\n        Chisago\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 441.14,
    y: 48.75,
    width: 63.25,
    height: 58.43,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.738333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 472.765,
    y: 77.965,
    fontFamily: "Arial"
  }, "\n        Nobles\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 504.39,
    y: 48.75,
    width: 63.25,
    height: 58.43,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.738333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 536.015,
    y: 77.965,
    fontFamily: "Arial"
  }, "\n        Steele\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 567.64,
    y: 48.75,
    width: 66.14,
    height: 58.43,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 14.6075
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 600.71,
    y: 77.965,
    fontFamily: "Arial"
  }, "\n        Pine\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 633.79,
    y: 48.75,
    width: 66.21,
    height: 58.43,
    style: {
      fill: "#660000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.738333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 666.895,
    y: 77.965,
    fontFamily: "Arial"
  }, "\n        Carver\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 88.88,
    y: 107.18,
    width: 63.38,
    height: 61.25,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.083333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 120.57,
    y: 137.805,
    fontFamily: "Arial"
  }, "\n        Yellow_Medicine\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 88.88,
    y: 168.43,
    width: 63.38,
    height: 62.9,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.483333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 120.57,
    y: 199.88,
    fontFamily: "Arial"
  }, "\n        Meeker\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 88.88,
    y: 231.32,
    width: 63.38,
    height: 64.41,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.9225
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 120.57,
    y: 263.525,
    fontFamily: "Arial"
  }, "\n        Le_Sueur\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 88.88,
    y: 295.73,
    width: 63.38,
    height: 65.45,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 15.845
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 120.57,
    y: 328.45500000000004,
    fontFamily: "Arial"
  }, "\n        Lyon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 88.88,
    y: 361.18,
    width: 63.38,
    height: 66.02,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.9225
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 120.57,
    y: 394.19,
    fontFamily: "Arial"
  }, "\n        Marshall\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 88.88,
    y: 427.2,
    width: 63.38,
    height: 66.71,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.563333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 120.57,
    y: 460.555,
    fontFamily: "Arial"
  }, "\n        Becker\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 88.88,
    y: 493.91,
    width: 63.38,
    height: 66.87,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.054285714285715
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 120.57,
    y: 527.345,
    fontFamily: "Arial"
  }, "\n        Wabasha\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 88.88,
    y: 560.78,
    width: 63.38,
    height: 68.86,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.563333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 120.57,
    y: 595.2099999999999,
    fontFamily: "Arial"
  }, "\n        Martin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 88.88,
    y: 629.64,
    width: 63.38,
    height: 70.36,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.054285714285715
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 120.57,
    y: 664.8199999999999,
    fontFamily: "Arial"
  }, "\n        Douglas\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 152.26,
    y: 107.18,
    width: 65.43,
    height: 68.47,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.347142857142858
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 184.975,
    y: 141.41500000000002,
    fontFamily: "Arial"
  }, "\n        Redwood\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 58,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 217.69,
    y: 107.18,
    width: 65.85,
    height: 68.47,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 16.4625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 250.615,
    y: 141.41500000000002,
    fontFamily: "Arial"
  }, "\n        Clay\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 59,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 283.54,
    y: 107.18,
    width: 66.26,
    height: 68.47,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.043333333333335
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 316.67,
    y: 141.41500000000002,
    fontFamily: "Arial"
  }, "\n        Itasca\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 60,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 349.8,
    y: 107.18,
    width: 67.34,
    height: 68.47,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.4175
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 383.47,
    y: 141.41500000000002,
    fontFamily: "Arial"
  }, "\n        Morrison\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 61,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 417.14,
    y: 107.18,
    width: 68.04,
    height: 68.47,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.340000000000002
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 451.15999999999997,
    y: 141.41500000000002,
    fontFamily: "Arial"
  }, "\n        McLeod\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 62,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 485.18,
    y: 107.18,
    width: 70.41,
    height: 68.47,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 13.693999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 520.385,
    y: 141.41500000000002,
    fontFamily: "Arial"
  }, "\n        Brown\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 63,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 555.59,
    y: 107.18,
    width: 71.72,
    height: 68.47,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.55875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 591.45,
    y: 141.41500000000002,
    fontFamily: "Arial"
  }, "\n        Beltrami\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 64,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 627.31,
    y: 107.18,
    width: 72.69,
    height: 68.47,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.607777777777778
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 663.655,
    y: 141.41500000000002,
    fontFamily: "Arial"
  }, "\n        Kandiyohi\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 65,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 152.26,
    y: 175.65,
    width: 69.45,
    height: 71.73,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.716666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 186.98499999999999,
    y: 211.51500000000001,
    fontFamily: "Arial"
  }, "\n        Crow_Wing\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 66,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 152.26,
    y: 247.38,
    width: 69.45,
    height: 73.46,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 17.3625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 186.98499999999999,
    y: 284.11,
    fontFamily: "Arial"
  }, "\n        Todd\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 67,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 152.26,
    y: 320.84,
    width: 69.45,
    height: 74.07,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 13.89
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 186.98499999999999,
    y: 357.875,
    fontFamily: "Arial"
  }, "\n        Mower\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 68,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 152.26,
    y: 394.91,
    width: 69.45,
    height: 74.55,
    style: {
      fill: "#660000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.716666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 186.98499999999999,
    y: 432.185,
    fontFamily: "Arial"
  }, "\n        Faribault\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 69,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 152.26,
    y: 469.45,
    width: 69.45,
    height: 74.97,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.945
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 186.98499999999999,
    y: 506.935,
    fontFamily: "Arial"
  }, "\n        Washington\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 70,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 152.26,
    y: 544.42,
    width: 69.45,
    height: 77.53,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.575000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 186.98499999999999,
    y: 583.185,
    fontFamily: "Arial"
  }, "\n        Dakota\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 71,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 152.26,
    y: 621.95,
    width: 69.45,
    height: 78.05,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.68125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 186.98499999999999,
    y: 660.975,
    fontFamily: "Arial"
  }, "\n        Renville\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 72,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 221.71,
    y: 175.65,
    width: 72.44,
    height: 75.96,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.055
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 257.93,
    y: 213.63,
    fontFamily: "Arial"
  }, "\n        Freeborn\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 73,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 294.16,
    y: 175.65,
    width: 74.91,
    height: 75.96,
    style: {
      fill: "#660000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.36375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 331.615,
    y: 213.63,
    fontFamily: "Arial"
  }, "\n        Fillmore\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 74,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 369.06,
    y: 175.65,
    width: 76.4,
    height: 75.96,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 18.99
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 407.26,
    y: 213.63,
    fontFamily: "Arial"
  }, "\n        Rice\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 75,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 445.47,
    y: 175.65,
    width: 77.33,
    height: 75.96,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.659999999999998
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 484.13500000000005,
    y: 213.63,
    fontFamily: "Arial"
  }, "\n        Wright\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 76,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 522.79,
    y: 175.65,
    width: 81.05,
    height: 75.96,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.85142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 563.3149999999999,
    y: 213.63,
    fontFamily: "Arial"
  }, "\n        Olmsted\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 77,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 603.84,
    y: 175.65,
    width: 96.16,
    height: 75.96,
    style: {
      fill: "#660000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.85142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 651.9200000000001,
    y: 213.63,
    fontFamily: "Arial"
  }, "\n        Goodhue\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 78,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 221.71,
    y: 251.61,
    width: 95.32,
    height: 78.6,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.859999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 269.37,
    y: 290.91,
    fontFamily: "Arial"
  }, "\n        Blue_Earth\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 79,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 221.71,
    y: 330.21,
    width: 95.32,
    height: 78.94,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 13.156666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 269.37,
    y: 369.67999999999995,
    fontFamily: "Arial"
  }, "\n        Winona\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 80,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 221.71,
    y: 409.15,
    width: 95.32,
    height: 82.44,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 20.61
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 269.37,
    y: 450.37,
    fontFamily: "Arial"
  }, "\n        Polk\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 81,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 221.71,
    y: 491.59,
    width: 95.32,
    height: 98.64,
    style: {
      fill: "#7F0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.532
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 269.37,
    y: 540.91,
    fontFamily: "Arial"
  }, "\n        Otter_Tail\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 82,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 221.71,
    y: 590.22,
    width: 95.32,
    height: 109.78,
    style: {
      fill: "#660000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 13.617142857142856
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 269.37,
    y: 645.11,
    fontFamily: "Arial"
  }, "\n        Stearns\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 83,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 317.03,
    y: 251.61,
    width: 159.8,
    height: 204.66,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 14.52727272727273
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 396.92999999999995,
    y: 353.94,
    fontFamily: "Arial"
  }, "\n        Saint_Louis\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 84,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 476.84,
    y: 251.61,
    width: 223.16,
    height: 204.66,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 34.11
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 588.42,
    y: 353.94,
    fontFamily: "Arial"
  }, "\n        Ramsey\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 85,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 317.03,
    y: 456.27,
    width: 382.97,
    height: 243.73,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 30.46625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 508.515,
    y: 578.135,
    fontFamily: "Arial"
  }, "\n        Hennepin\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1920);
export default __webpack_public_path__ + "static/media/1920.f5b6f7f0b5248b515d077dd350851ad0.svg";
export { ForwardRef as ReactComponent };